import React from "react";

/**
 * check if a value is controlled by the caller. The result does not change
 * accross renders. Once a value is controlled, it should stay as controlled.
 */
export const useIsControlled = value => {
  const isControlled = React.useRef(value !== undefined).current;
  const lastIsControlled = value !== undefined;
  if (lastIsControlled !== isControlled) {
    process.env.NODE_ENV !== 'production' ? console.warn('A value changed from controlled to uncontrolled. This has no effect but indicates a bug.') : void 0;
  }
  return isControlled;
};